var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 112C160 120.801 167.201 128 176 128H256V192H176C167.201 192 160 199.199 160 208S167.201 224 176 224H256V288H176C167.201 288 160 295.199 160 304S167.201 320 176 320H256V384H176C167.201 384 160 391.199 160 400S167.201 416 176 416H256V480C256 497.6 241.6 512 224 512H32C14.4 512 0 497.6 0 480V32C0 14.4 14.4 0 32 0H224C241.6 0 256 14.4 256 32V96H176C167.201 96 160 103.199 160 112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerVertical);
export default __webpack_public_path__ + "static/media/ruler-vertical.c7ec3c14bc1b030784c271b8be6acb94.svg";
export { ForwardRef as ReactComponent };